import { useContext, useEffect, useRef, useState } from 'react';
import { DashboardContext } from '../contexts/DashboardContext';

const LoadedQueryCriteria = ['Description', 'Team', 'Digest', 'Location', 'Questions'];

const useQueriesLoadedChecker = () => {
  const { dashboardQueries } = useContext(DashboardContext);

  const [queriesLoaded, setQueriesLoaded] = useState<boolean>(false);
  const [count, setCount] = useState<number>(0);
  const [timer, setTimer] = useState<string | number | NodeJS.Timeout | undefined>(undefined);
  const timeOutRef = useRef<boolean>(false);

  useEffect(() => {
    if (dashboardQueries.filter((query) => LoadedQueryCriteria.includes(query.title) && !!query.answer)?.length > 2) {
      timeOutRef.current = true;
    } else if (count === 0) {
      setTimer(setInterval(() => setCount(prev => prev + 1), 1000));
    } else if (count > 5) {
      timeOutRef.current = true;
    }

    if (timeOutRef.current) {
      setQueriesLoaded(true);

      return () => {
        clearInterval(timer);
      }
    }
    //eslint-disable-next-line
  }, [count]);

  return { queriesLoaded };
};

export default useQueriesLoadedChecker;